import { render } from "./SteuerpflichtigeCountries.vue?vue&type=template&id=35c514d9"
import script from "./SteuerpflichtigeCountries.vue?vue&type=script&lang=js"
export * from "./SteuerpflichtigeCountries.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__